import axios from 'axios';
import {useAuthStore} from '@store';
import {AuthUrlMap} from './auth.service';

const FrontEndApiService = {
    _401interceptor: null,
    _requestInterceptor: null,

    init(baseURL) {
        axios.defaults.baseURL = baseURL;
    },

    get(resource) {
        return axios.get(resource);
    },

    post(resource, data) {
        return axios.post(resource, data);
    },

    put(resource, data) {
        return axios.put(resource, data);
    },

    delete(resource) {
        return axios.delete(resource);
    },

    customRequest(data) {
        return axios(data);
    },

    mount401Interceptor() {
        this._401interceptor = axios.interceptors.response.use(
            (response) => {
                return response;
            },
            async (error) => {
                if (error.request.status === 401) {
                    const storeAuth = useAuthStore();

                    let doLogout = error.config.url.includes(AuthUrlMap.LOGIN) ||
                        error.config.url.includes(AuthUrlMap.LOGIN_THIRD_PARTY);

                    if (doLogout) {
                        // Refresh token has failed. Logout the user
                        await storeAuth.logout();
                        throw error;
                    } else {
                        // Refresh the access token
                        try {
                            await storeAuth.refreshTokenRequest();
                            // Retry the original request
                            return this.customRequest({
                                method: error.config.method,
                                url: error.config.url,
                                data: error.config.data,
                            });
                        } catch (e) {
                            if (e.errorCode && [401, 500].includes(parseInt(e.errorCode))) {
                                // Refresh token has failed. Logout the user
                                await storeAuth.logout();
                            }

                            // Refresh has failed - reject the original request
                            throw error;
                        }
                    }
                }

                // If error was not 401 just reject as is
                throw error;
            }
        )
    },

    mountRequestInterceptor() {
        const storeAuth = useAuthStore();
        FrontEndApiService.mountRequestAuthInterceptor(storeAuth.accessToken);
    },

    mountRequestAuthInterceptor(accessToken = '') {
        this._requestInterceptor = axios.interceptors.request.use((config) => {
            config.headers.common['Milestones-Authorization'] = `Bearer ${accessToken}`;

            return config;
        });
    },

    unmount401Interceptor() {
        axios.interceptors.response.eject(this._401interceptor);
    },

    unmountRequestInterceptor() {
        axios.interceptors.response.eject(this._requestInterceptor);
    },
};

export default FrontEndApiService;
